
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierDescriptif.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierDescriptif.ts

import {SupplierAgency } from "./SupplierAgency";
import {SupplierContact } from "./SupplierContact";
export class SupplierDescriptif {

  // int Id
  public Id: number=0;

  // string SupplierName
  public SupplierName?: string=null;

  // int? LegalFormId
  public LegalFormId?: number=null;

  // string Siret
  public Siret?: string=null;

  // string Rsa
  public Rsa?: string=null;

  // string Duns
  public Duns?: string=null;

  // string TvaIntra
  public TvaIntra?: string=null;

  // string WebSite
  public WebSite?: string=null;

  // int? ApeId
  public ApeId?: number=null;

  // int? WithAgencies
  public WithAgencies?: number=null;

  // string LngCod
  public LngCod?: string=null;

  // string GroupName
  public GroupName?: string=null;

  // string HQSiret
  public HQSiret?: string=null;

  // string ApiSirenResult
  public ApiSirenResult?: string=null;

  // string FunctionalId
  public FunctionalId?: string=null;

  // ICollection<SupplierAgency> SupplierAgencies
  public SupplierAgencies: SupplierAgency[]=[];

  // ICollection<SupplierContact> SupplierContacts
  public SupplierContacts: SupplierContact[]=[];

  // int RefStep
  public RefStep: number=0;

  // string InternalContactFirstname
  public InternalContactFirstname?: string=null;

  // string InternalContactLastname
  public InternalContactLastname?: string=null;

  // string InternalContactEmail
  public InternalContactEmail?: string=null;
}